import React, { Component } from "react";
import { Grid, Box, Typography, Tab } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";

import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  getLastDayofMonthofGivenDate,
  get_FirstDate_of_Given_YMD_Date,
  validatedate_min_max,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchGSTDetails } from "./API";
import ExcelJS from "exceljs";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import SalesPurchaseReport from "./SalesPurchaseReport";
import ExcelGSTR3B from "./ExcelGSTR3B";
import ExcelGSTR1 from "./ExcelGSTR1";

class MultipleGSTReturn extends Component {
  state = {
    formData: {
      value: "1",
    },
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : GST Reports";
    this.props.setActiveMenu("MultipleGSTReturn");
    this.props.verifyUserID(
      undefined,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#endregion handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnChangeTab = (event, newValue) => {
    this.setState({
      formData: { ...this.state.formData, value: newValue },
    });
  };

  //#region handle

  //#region function

  //#endregion function

  render() {
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>GST Return</b>
          </label>
        </Grid> */}
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={this.state.formData.value}>
            <Box
              sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}
            >
              <TabList
                onChange={this.handleOnChangeTab}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Sales Purchase Summary" value="1" />
                <Tab label="GSTR-1" value="2" />
                <Tab label="GSTR-3B" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <SalesPurchaseReport />
            </TabPanel>
            <TabPanel value="2">
              <ExcelGSTR1 />
            </TabPanel>
            <TabPanel value="3">
              <ExcelGSTR3B />
            </TabPanel>
          </TabContext>
          <Grid item>
            <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
              {this.state.ARD}
            </Box>
          </Grid>
        </Box>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(MultipleGSTReturn))));
